(function() {
    'use strict';

    angular.module('vhols')
        .service('cookieExpiryService', function () {
            this.compute = function (expirationTime) {
                var numChars = expirationTime.length;
                var numMultiplier = parseInt(expirationTime.substring(0, numChars - 1));
                var timePeriod = expirationTime.substring(numChars, numChars - 1);
                var now = new Date();
                var multiplier = numMultiplier * 60 * 1000;

                if (timePeriod == 'm') {
                    now.setTime(now.getTime() + (multiplier));
                } else if (timePeriod == 'h') {
                    now.setTime(now.getTime() + (multiplier * 60));
                } else if (timePeriod == 'd') {
                    now.setTime(now.getTime() + (multiplier * 60 * 24));
                } else if (timePeriod == 'w') {
                    now.setTime(now.getTime() + (multiplier * 60 * 24 * 7));
                }
                // if cannot parse return the same date
                return now;
            };
        });
})();